import {
  LinkifyProductNames,
  type ProductLink,
} from '~/src/components/reports/LinkifyProductNames'

interface SeoReportQuickAnswerProps {
  title: string
  body: string
  productLinks?: ProductLink[]
}

export function SeoReportQuickAnswer({
  title,
  body,
  productLinks,
}: SeoReportQuickAnswerProps) {
  const paragraphs = body
    .split(/\n\n+/)
    .map((p) => p.trim())
    .filter(Boolean)

  return (
    <aside aria-label='Quick answer' id='quick-answer'>
      <div className='flex flex-col gap-6'>
        <h2 className='sr-only'>{title}</h2>
        <div className='text-base leading-7 text-foreground md:text-lg'>
          {paragraphs.map((paragraph, index) => (
            <p
              key={index}
              className={index < paragraphs.length - 1 ? 'mb-[18px]' : ''}
            >
              {productLinks && productLinks.length > 0 ? (
                <LinkifyProductNames text={paragraph} products={productLinks} />
              ) : (
                paragraph
              )}
            </p>
          ))}
        </div>
      </div>
    </aside>
  )
}
